import { handleClickColor, timezones } from "../../Common/Util";

export function NavamsaChart ({navamsaHouseData,userData,clientData}) {
  const firstrowloop = [11,0,1,2];
  const secondrowloop = [10,3];
  const thirdrowloop = [9,4];
  const lastrowloop = [8,7,6,5];
  const trheight = {height: "12vh"};

  return(
    <>
    <table class="m-0 p-0 table">
      <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Navamsa Chart</h4></caption>
    </table>
    <table class="m-0 p-0 table align-middle text-center">
      <tbody class="m-0 p-0">
        <tr class="m-0 p-0" style={trheight}>
        {firstrowloop.map((firstrowcol) => (
          <td class="m-0 p-0 border border-1 border-primary w-25" onClick={handleClickColor}>
          {(navamsaHouseData[firstrowcol]===undefined || navamsaHouseData[firstrowcol].length===0)?(<></>):(
            navamsaHouseData[firstrowcol].map((planet) => (
              <>{planet.substring(0,3)}<br/></>
            ))
          )}
          </td>
        ))}
        </tr>  

        <tr class="m-0 p-0" style={trheight}>
        {secondrowloop.map((secondrowcol,colindex) => (
        <>
          <td class="m-0 p-0 border border-1 border-primary" onClick={handleClickColor}>
          {(navamsaHouseData[secondrowcol]===undefined || navamsaHouseData[secondrowcol].length===0)?(<></>):(
            navamsaHouseData[secondrowcol].map((planet) => (
              <>{planet.substring(0,3)}<br/></>
            ))
          )}
          </td>
          {colindex!==0?<></>:
          <td class="m-0 p-0 text-center border-primary" colSpan="2" rowSpan="2">
            <b>NAVAMSA CHART</b><br/>
            <br/>{userData.firstName+" "+userData.lastName}
            <br/>{userData.birthDate} {userData.birthDay} 
            <br/>{userData.birthTimeCorrected===null?userData.birthTime:userData.birthTimeCorrected} {timezones.find(tz => tz.value === userData.birthTimezone).label.substring(1,10)}
            <br/>{userData.birthCity}
            <br/>Lat:{userData.birthLatitude} Lon:{userData.birthLongitude}
            <br/>{clientData.ayanamsaName} : {clientData.ayanamsaDegree}
          </td>}
        </>))}
        </tr>  

        <tr class="m-0 p-0" style={trheight}>
        {thirdrowloop.map((thirdrowcol) => (
          <td class="m-0 p-0 border border-1 border-primary" onClick={handleClickColor}>
          {(navamsaHouseData[thirdrowcol]===undefined || navamsaHouseData[thirdrowcol].length===0)?(<></>):(
            navamsaHouseData[thirdrowcol].map((planet) => (
              <>{planet.substring(0,3)}<br/></>
            ))
          )}
          </td>
        ))}
        </tr>  

        <tr class="m-0 p-0" style={trheight}>
        {lastrowloop.map((lastrowcol) => (
          <td class="border border-1 p-0 border-primary" onClick={handleClickColor}>
          {(navamsaHouseData[lastrowcol]===undefined || navamsaHouseData[lastrowcol].length===0)?(<></>):(
            navamsaHouseData[lastrowcol].map((planet) => (
              <>{planet.substring(0,3)}<br/></>
            ))
          )}
          </td>
        ))}
        </tr>  
      </tbody>
    </table>
    </>
  );
}